import {http} from "http/index";

export const checkEmailAvailability = email =>
  http.post("/agent/user/check-email-availability", {email});

export const resendVerificationEmail = ({email}) =>
  http.post("/agent/user/resend-activation", {email});
